/**
 * Created by bootdo.
 *
 */
import * as API from '.'
import $const from '../common/constant'
export default {
  saveOrUpdate: params => {
    return API.POST($const.apiServer.Tranning+'/question-bank/admin/save',params);
  },
  pageList:params => {
    return API.GET($const.apiServer.Tranning+'/question-bank/admin/page-list',params)
  },
  del:params => {
    console.log(params)
    return API.POST($const.apiServer.Tranning+'/question-bank/admin/del/'+params)
  },
  batchImportQuestion: params => {
    return API.POST($const.apiServer.Tranning+'/question-bank/admin/batch-import-question', params)
  },
  questionBankAdmin: params => {
    return API.POST($const.apiServer.Tranning+'/question-bank/admin',params);
  },
}



// WEBPACK FOOTER //
// ./src/api/api_question_bank.js